'use client';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import styles from './input.module.scss';

class Input extends PureComponent {
  static propTypes = {
    /** Required: the unique id of the checkbox input */
    id: PropTypes.string.isRequired,
    /** The input element's type */
    type: PropTypes.string,
    /** Custom class name to be applied */
    className: PropTypes.string,
    /** The name of the input element */
    name: PropTypes.string.isRequired,
    /** The value of the input (if applicable) */
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    /** The defaultValue of the input (if applicable) */
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    /** Function to be called when a change event is fired by the input */
    onChange: PropTypes.func,
    /** Function to be called when the input accepts focus */
    onFocus: PropTypes.func,
    /** Function to be called when the input loses focus */
    onBlur: PropTypes.func,
    /** Placeholder text to appear if input is empty */
    placeholder: PropTypes.string,
    /** Set maximum number of characters to be accepted */
    maxLength: PropTypes.number,
    /** Focus on this input when the page loads */
    autoFocus: PropTypes.bool,
    /**  */
    autoComplete: PropTypes.string,
    /** Mark the textarea as readonly so it can't be edited */
    readOnly: PropTypes.bool,
    /** Set the aria-label attribute */
    ariaLabel: PropTypes.string,
    /** Set the aria-invalid attribute */
    ariaInvalid: PropTypes.string,
    /** Set the aria-describedby attribute */
    ariaDescribedBy: PropTypes.string,
    /** Disable the textarea element */
    disabled: PropTypes.bool,
    /** Mark the input element as a required field */
    required: PropTypes.bool,
    /**  */
    extensionProps: PropTypes.objectOf(PropTypes.any),
  };

  static defaultProps = {
    className: undefined,
    type: 'text',
    //
    value: '',
    onChange: () => {},
    onFocus: () => {},
    onBlur: () => {},
    //
    placeholder: undefined,
    maxLength: null,
    autoFocus: false,
    autoComplete: 'on',
    readOnly: false,
    ariaLabel: undefined,
    ariaInvalid: undefined,
    ariaDescribedBy: undefined,
    disabled: false,
    required: false,
    defaultValue: undefined,
    //
    extensionProps: {},
  };

  render() {
    const {
      id,
      type,
      className,
      //
      name,
      value,
      onChange,
      onFocus,
      onBlur,
      //
      placeholder,
      maxLength,
      autoFocus,
      autoComplete,
      readOnly,
      ariaLabel,
      ariaInvalid,
      ariaDescribedBy,
      disabled,
      required,
      defaultValue,
      //
      extensionProps,
    } = this.props;

    const valueProp = defaultValue !== undefined ? { defaultValue } : { value };

    return (
      <input
        className={classNames(styles['c-input'], className)}
        id={id}
        name={name}
        type={type}
        {...valueProp}
        ref={(el) => {
          this.input = el;
        }}
        aria-describedby={ariaDescribedBy}
        aria-invalid={ariaInvalid}
        aria-label={ariaLabel}
        autoComplete={autoComplete}
        autoFocus={autoFocus} // eslint-disable-line jsx-a11y/no-autofocus
        disabled={disabled}
        maxLength={maxLength}
        onBlur={onBlur}
        onChange={onChange}
        onFocus={onFocus}
        placeholder={placeholder}
        readOnly={readOnly}
        required={required}
        {...extensionProps}
        data-jlds={true}
        data-testid="input"
      />
    );
  }
}

export default Input;
